<div class="stat-grid">
    <app-stat-card
            title="Total<br>Facilities"
            [value]="total_facilities"
            icon="local_hospital"
            variant="primary">
    </app-stat-card>

    <app-stat-card
            title="Total<br>Deliveries"
            [value]="total_deliveries"
            icon="directions_walk"
            variant="warning">
    </app-stat-card>

    <app-stat-card
            title="Total<br>Amount"
            [value]="total_amount"
            icon="attach_money"
            variant="success">
    </app-stat-card>

    <app-stat-card
            title="Unpaid<br>Trips"
            [value]="total"
            icon="inventory_2"
            variant="danger">
    </app-stat-card>
</div>

<app-filter-bar
        [fields]="fields"
        [initialValues]="{}"
        (apply)="onApply($event)"
        (reset)="onReset()">
</app-filter-bar>


<!-- Upload toolbar (new) -->
<div class="upload-toolbar">
    <button mat-flat-button color="primary" (click)="downloadReport()">
        <mat-icon>download_file</mat-icon>
        Download Report
    </button>

    <span class="spacer"></span>

    <button mat-stroked-button color="primary" (click)="refresh(null)" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
    </button>
</div>
<!-- Optional progress -->
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<!-- Table -->
<div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1" [multiTemplateDataRows]="true">

        <!-- Facility Name -->
        <ng-container matColumnDef="facility_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Facility Name</th>
            <td mat-cell *matCellDef="let row"> {{ row.facility_name }}</td>
        </ng-container>

        <!-- CCC -->
        <ng-container matColumnDef="ccc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CCC</th>
            <td mat-cell *matCellDef="let row"> {{ row.ccc }}</td>
        </ng-container>

        <!-- Start -->
        <ng-container matColumnDef="enrolment_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment Date</th>
            <td mat-cell *matCellDef="let row"> {{ row.enrolment_date }}</td>
        </ng-container>

        <!-- End -->
        <ng-container matColumnDef="delivery_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Date</th>
            <td mat-cell *matCellDef="let row"> {{ row.delivery_date }}</td>
        </ng-container>

        <!-- Distance -->
        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef> Amount ({{currency}})</th>
            <td mat-cell *matCellDef="let row">{{ row.amount }}</td>
        </ng-container>

        <!-- Distance -->
        <ng-container matColumnDef="payment_type">
            <th mat-header-cell *matHeaderCellDef> Incentive Type</th>
            <td mat-cell *matCellDef="let row">{{ row.payment_type }}</td>
        </ng-container>

        <!-- Deliveries (count) -->
        <ng-container matColumnDef="narration">
            <th mat-header-cell *matHeaderCellDef> Narration</th>
            <td mat-cell *matCellDef="let row">
                {{ row.narration }}
            </td>
        </ng-container>

        <!-- Created -->
        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created</th>
            <td mat-cell *matCellDef="let row"> {{ row.created_at | date:'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions</th>
            <td mat-cell *matCellDef="let row">
                <button mat-stroked-button color="primary" (click)="viewTrip(row)">
                    <span class="btn-label">{{ expandedElement === row ? 'Hide' : 'View' }}</span>
                </button>


            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


    </table>

    <mat-paginator [length]="total"
                   [pageSize]="pageSize"
                   [pageIndex]="filters.page - 1"
                   [pageSizeOptions]="[10,25,50,100]"
                   (page)="onPage($event)">
    </mat-paginator>
</div>

